import { render, staticRenderFns } from "./podcasts.vue?vue&type=template&id=2d4b48b5&scoped=true&"
import script from "./podcasts.vue?vue&type=script&lang=js&"
export * from "./podcasts.vue?vue&type=script&lang=js&"
import style0 from "@/assets/main.css?vue&type=style&index=0&id=2d4b48b5&scoped=true&lang=css&"
import style1 from "./podcasts.vue?vue&type=style&index=1&id=2d4b48b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b48b5",
  null
  
)

export default component.exports